/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelSlot64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelSlot64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M17 47H17.4688V48H16.5C16.2239 48 16 47.7761 16 47.5V46.5312H17V47Z"
              fill="currentColor"
            />
            <path d="M21.3438 48H19.4062V47H21.3438V48Z" fill="currentColor" />
            <path d="M25.2188 48H23.2812V47H25.2188V48Z" fill="currentColor" />
            <path d="M29.0938 48H27.1562V47H29.0938V48Z" fill="currentColor" />
            <path d="M32.9688 48H31.0312V47H32.9688V48Z" fill="currentColor" />
            <path d="M36.8438 48H34.9062V47H36.8438V48Z" fill="currentColor" />
            <path d="M40.7188 48H38.7812V47H40.7188V48Z" fill="currentColor" />
            <path d="M44.5938 48H42.6562V47H44.5938V48Z" fill="currentColor" />
            <path
              d="M48 47.5L47.9902 47.6006C47.9437 47.8286 47.7417 48 47.5 48H46.5312V47H47V46.5312H48V47.5Z"
              fill="currentColor"
            />
            <path d="M17 44.5938H16V42.6562H17V44.5938Z" fill="currentColor" />
            <path d="M48 44.5938H47V42.6562H48V44.5938Z" fill="currentColor" />
            <path d="M17 40.7188H16V38.7812H17V40.7188Z" fill="currentColor" />
            <path d="M48 40.7188H47V38.7812H48V40.7188Z" fill="currentColor" />
            <path
              d="M32.5 26.5V31.5H37.5V32.5H32.5V37.5H31.5V32.5H26.5V31.5H31.5V26.5H32.5Z"
              fill="currentColor"
            />
            <path d="M17 36.8438H16V34.9062H17V36.8438Z" fill="currentColor" />
            <path d="M48 36.8438H47V34.9062H48V36.8438Z" fill="currentColor" />
            <path d="M17 32.9688H16V31.0312H17V32.9688Z" fill="currentColor" />
            <path d="M48 32.9688H47V31.0312H48V32.9688Z" fill="currentColor" />
            <path d="M17 29.0938H16V27.1562H17V29.0938Z" fill="currentColor" />
            <path d="M48 29.0938H47V27.1562H48V29.0938Z" fill="currentColor" />
            <path d="M17 25.2188H16V23.2812H17V25.2188Z" fill="currentColor" />
            <path d="M48 25.2188H47V23.2812H48V25.2188Z" fill="currentColor" />
            <path d="M17 21.3438H16V19.4062H17V21.3438Z" fill="currentColor" />
            <path d="M48 21.3438H47V19.4062H48V21.3438Z" fill="currentColor" />
            <path
              d="M17.4688 17H17V17.4688H16V16.5C16 16.2583 16.1714 16.0563 16.3994 16.0098L16.5 16H17.4688V17Z"
              fill="currentColor"
            />
            <path
              d="M47.6006 16.0098C47.8286 16.0563 48 16.2583 48 16.5V17.4688H47V17H46.5312V16H47.5L47.6006 16.0098Z"
              fill="currentColor"
            />
            <path d="M21.3438 17H19.4062V16H21.3438V17Z" fill="currentColor" />
            <path d="M25.2188 17H23.2812V16H25.2188V17Z" fill="currentColor" />
            <path d="M29.0938 17H27.1562V16H29.0938V17Z" fill="currentColor" />
            <path d="M32.9688 17H31.0312V16H32.9688V17Z" fill="currentColor" />
            <path d="M36.8438 17H34.9062V16H36.8438V17Z" fill="currentColor" />
            <path d="M40.7188 17H38.7812V16H40.7188V17Z" fill="currentColor" />
            <path d="M44.5938 17H42.6562V16H44.5938V17Z" fill="currentColor" />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelSlot64Icon.tags = ['add', 'panel', 'slot', 'new', 'insert'];

AddPanelSlot64Icon.category = '64x64 (Add panel)';

AddPanelSlot64Icon.iconSize = 64;
